<!--
 * @Author: shiao
 * @Date: 2021-01-04 10:18:54
 * @LastEditTime: 2021-02-01 17:45:40
 * @Description: 酒店入住详情
 * @LastEditors: shiao
 * @FilePath: \o2o-appd:\gongsi\h5-hotel\h5\src\pages\hotel\detail\detailinfo.vue
-->
<template>
  <div class="detailinfo-body" ref="detailinfobodyScroll">
    <div class="detailinfo-nav">
      <navbar title="酒店信息" :lefticon="returnblackicon" :lefticonheight="1.5" :lefticonwidth="1.5" @goback="goback" :fontweight="500"/>
      <div class="second-nav">
        <div :class="activateIndex == 1 ? 'nav-activate' : 'nav-div'" @click="changeIndex(1)">酒店亮点</div>
        <div :class="activateIndex == 2 ? 'nav-activate' : 'nav-div'" @click="changeIndex(2)">入住政策</div>
        <div :class="activateIndex == 3 ? 'nav-activate' : 'nav-div'" @click="changeIndex(3)">酒店设施</div>
      </div>
    </div>
    <div class="filling-div"></div>
    <div class="hotel-info" ref="hotelInfoRef" v-show="activateIndex == 1">
      <div>
        <span class="one-title">{{ hotelinfo.chinese_name }}</span>
        <span class="hotel-tag">{{ hotelinfo.starName }}</span>
      </div>
      <div class="hotel-description-div">
        <span class="hotel-description">{{
            hotelinfo.openYear ? hotelinfo.openYear.split("-")[0] : ""
          }}年开业</span>
      </div>
      <div class="three-div">
        <div class="three-left-title">酒店电话：</div>
        <div class="three-right-div">
          <div class="three-phone-div" v-for="(item, index) in hotelinfo.tel" :key="index" @click="callphone(item)">
            <div class="three-phone">{{ item }}</div>
            <div class="three-img">
              <img :src="callphonegreenicon" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="one-title">酒店介绍</div>
      <div class="first-img" v-show="hotelimages.length > 0" @click="startPrewive(0)">
        <img :src="hotelimages.length > 0 ? hotelimages[0] : ''" alt="" />
      </div>
      <div class="info-text-div" v-html="hotelinfo.descriptions"></div>
      <div class="first-img" v-show="hotelimages.length > 1" @click="startPrewive(1)">
        <img :src="hotelimages.length > 1 ? hotelimages[1] : ''" alt="" />
      </div>
      <div class="hotel-qualification-btn" @click="goqualification">
        <div class="resourceicon"><img :src="resourcesgreenicon" alt="" /></div>
        <div class="qualification-text">酒店商家资质</div>
        <div class="rightarrowicon">
          <img :src="rightarrowblackicon" alt="" />
        </div>
      </div>
    </div>
    <div class="checkin-info" ref="checkininforef" v-show="activateIndex == 2">
      <div class="one-title"><img :src="readwarningicon" alt="" />订房必读</div>
      <div class="read-text read-right-indent" v-for="(item, index) in hotelinfo.mustRead"
        :key="index">
        {{ item.Text }}
      </div>
      <div class="one-title">入离时间</div>
      <div class="check-in-out">
        <div>
          <div class="checkin-title">入住</div>
          <div class="read-div-text">{{ hotelinfo.checkintime }}</div>
        </div>
        <div>
          <div>离店</div>
          <div>{{ hotelinfo.checkouttime }}</div>
        </div>
      </div>
      <div class="one-title">儿童及加床</div>
      <div class="read-text-little" v-html="policy(hotelinfo.policy, 'Child') "></div>
      <div class="one-title">宠物</div>
      <div class="read-text-little" v-html="policy(hotelinfo.policy, 'Pet')"></div>
      <div class="one-title">早餐</div>
      <div class="read-text-little" v-html="policy(hotelinfo.policy, 'Meal')"></div>
      <div class="one-title">预订提示</div>
      <div class="read-text-little-old">
        订单需等酒店或供应商确认后生效，订单确认结果以携程短信或邮件通知为准
      </div>
      <div class="one-title">年龄限制</div>
      <div class="read-text-little-old">入住办理人需年满18岁</div>
    </div>
    <div class="hotel-facility-info" ref="hotelfacilityinfo" v-show="activateIndex == 3">
      <div class="hotel-facility-title">酒店设施</div>
      <div class="hotel-facility-div">
        <div>
          <div class="read-div-text" v-for="(item, index) in computedfacilities[0]" :key="index">{{ item.Text }}
          </div>
        </div>
        <div>
          <div class="read-div-text" v-for="(item, index) in computedfacilities[1]" :key="index">
            {{ item.Text }}
          </div>
        </div>
      </div>
    </div>
    <div class="detailinfo-bottom-div">
      <div class="bottom-div-left">
        <div class="room-price-div">
          <div class="room-price-red">
            <span>¥</span><span class="room-price-number">{{ hotelinfo.LowerPrice }}</span>
          </div>
          <div class="room-price-text-img">起</div>
        </div>
        <div class="room-orange-text-img" @click="goback">
          查看更多价格<img :src="rightarroworangeicon" alt="" />
        </div>
      </div>
      <div class="hotel-room-btn" @click="goback">查看房型</div>
    </div>
    <imagepreview :previewshow="previewshow" :previewimages="hotelimages" :prewivewIndex="prewivewIndex"
      @closeImagePreview="closeImagePreview" />
  </div>
</template>

<script>
  import navbar from "../components/nav-bar.vue";
  import imagepreview from "../components/image-preview.vue";
  import {mapState,mapMutations} from 'vuex'
  export default {
    components: {
      navbar,
      imagepreview
    },
    data() {
      return {
        returnblackicon: require("@/assets/hotel/img/micon/return-black-icon.png"),
        callphonegreenicon: require("@/assets/hotel/img/micon/callphone-green-icon.png"),
        rightarrowblackicon: require("@/assets/hotel/img/micon/right-arrow-black-icon.png"),
        resourcesgreenicon: require("@/assets/hotel/img/detail/resources-green-icon.png"),
        rightarroworangeicon: require("@/assets/hotel/img/micon/right-arrow-orange-icon.png"),
        readwarningicon: require("@/assets/hotel/img/micon/read-warning-icon.png"),
        activateIndex: 1, //当前的页面切换位置
        hotelinfo: {}, //酒店详情信息
        prewivewIndex: 0, //图片预览的起始位置
        previewshow: false, //图片放大查看是否
      };
    },
    computed: {
      ...mapState({
        hoteldetail: (state) => state.hotel.hoteldetail,
      }),
      computedfacilities() {
        let onelist = [];
        let twolist = [];
        for (let i in this.hotelinfo.facilities) {
          if (i % 2 == 0) {
            onelist.push(this.hotelinfo.facilities[i]);
          } else {
            twolist.push(this.hotelinfo.facilities[i]);
          }
        }
        return [onelist, twolist];
      },
      hotelimages() {
        return this.hotelinfo ? this.hotelinfo.pictures.official.public_area.slice(0, 2) : [];
      },
    },
    created() {
      this.hotelinfo = this.hoteldetail.hotelinfo
      let descriptionsList = this.hotelinfo.descriptions.split('<br>')
      let descriptionsHtml = ''
      for(let i in descriptionsList){
        if(i>=1){
          descriptionsHtml += '<p style="margin-top:1rem">' + descriptionsList[i] + '</p>'
        }else{
          descriptionsHtml += descriptionsList[i] 
        }
      }
      this.hotelinfo.descriptions = descriptionsHtml
    },
    mounted() {
      this.changeIndex(this.hoteldetail.detailActiavteNum)
    },
    methods: {
      ...mapMutations(["setState"]),
      //返回上一页
      goback() {
        this.$router.go(-1);
      },
      changeIndex(num) {
        this.$refs.detailinfobodyScroll.scrollTop = 0;
        this.activateIndex = num;
        this.hoteldetail.detailActiavteNum = num
      },
      policy(item, name) {
        for (let i in item) {
          if (item[i].code == name) {
            let policyList = item[i].Text.split('<br/>')
            let policyHtml = ''
            for (let i in policyList){
              policyHtml += '<p style="margin-top:1rem;">' + policyList[i]
            }
            return policyHtml;
          }
        }
      },
      //拨打电话
      callphone(tel) {
        if (tel) {
          window.location.href = `tel://${tel}`;
        }
      },
      //开启图片预览
      startPrewive(index) {
        this.previewshow = true
        this.prewivewIndex = index
      },
      //关闭图片预览
      closeImagePreview() {
        this.previewshow = false
      },
      //前往商家资质页面
      goqualification() {
        this.$router.push({
          path: "/hotel/qualificationinfo",
        });
      },
    },
  };
</script>
<style>
  html {
    font-size: calc(var(--sizeScale2) * 10px);
  }
</style>
<style lang="less" scoped>
  html,
  body {
    overflow-x: hidden !important;
  }

  .filling-div {
    width: 100%;
    height: 12.7rem;
  }

  .detailinfo-body {
    background: #fbfbfb;
    height: 100%;
    overflow: scroll;

    .detailinfo-nav {
      padding-top: 4.4rem;
      background: #ffffff;
      box-shadow: 0rem 0.5rem 1.0rem 0rem rgba(19, 19, 19, 0.1);
      position: fixed;
      top: 0;
      width: 100%;
      z-index: 5;
      background-color: #fff;

      .second-nav {
        height: 3.9rem;
        display: flex;
        padding: 0 3.0rem;

        .nav-div,
        .nav-activate {
          flex: 1;
          height: 2.2rem;
          font-size: 1.6rem;
          font-weight: 400;
          color: #999999;
          line-height: 2.2rem;
          text-align: center;
        }

        .nav-activate {
          font-weight: 500;
          color: #333333;
          position: relative;

          &::before {
            position: absolute;
            bottom: -0.5rem;
            content: "";
            width: 3.0rem;
            height: 0.4rem;
            background: #108b30;
            border-radius: 0.2rem;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
    }
  }

  .hotel-info {
    padding: 3.0rem 1.5rem 10.0rem;

    .one-title {
      height: 2.4rem;
      font-size: 1.7rem;
      font-weight: 500;
      color: #333333;
      line-height: 2.4rem;
    }

    .hotel-tag {
      width: 3.6rem;
      height: 1.7rem;
      font-size: 1.2rem;
      font-weight: 400;
      color: #666666;
      line-height: 1.7rem;
      margin-left: 0.9rem;
    }

    .hotel-description-div {
      padding: 1.0rem 0 2.0rem;

      .hotel-description {
        height: 1.7rem;
        font-size: 1.2rem;
        font-weight: 400;
        color: #999999;
        line-height: 1.7rem;
        margin-right: 1.0rem;
      }
    }
  }

  .three-div {
    display: flex;
    font-size: 1.5rem;
    font-weight: 400;
    color: #333333;
    line-height: 2.1rem;
    padding-bottom: 3.0rem;

    .three-left-title {
      width: auto;
    }

    .three-right-div {
      flex: 1;

      .three-phone-div {
        height: 2.0rem;
        line-height: 2.0rem;

        .three-phone,
        .three-img {
          display: inline-block;
          vertical-align: top;
        }

        &:last-child {
          margin-top: 1.0rem;
        }

        &:first-child {
          margin-top: 0;
        }
      }

      .three-img {
        width: 2.0rem;
        height: 2.0rem;
        float: right;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .first-img {
    border-radius: 1.0rem;
    overflow: hidden;
    margin-top: 2.0rem;
    height: 20.0rem;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .info-text-div {
    font-size: 1.4rem;
    font-weight: 400;
    color: #666666;
    line-height: 2.3rem;
    margin: 2.0rem 0;
    br{
      margin-top: 1rem;
    }
  }

  .hotel-qualification-btn {
    margin-top: 3.0rem;

    .resourceicon {
      vertical-align: top;
      display: inline-block;
      margin-top: 0.3rem;
      width: 1.6rem;
      height: 1.8rem;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .qualification-text {
      display: inline-block;
      height: 2.4rem;
      font-size: 1.7rem;
      font-weight: 500;
      color: #333333;
      line-height: 2.4rem;
      margin-left: 1.0rem;
      vertical-align: top;
    }

    .rightarrowicon {
      float: right;
      width: 1.2rem;
      height: 1.2rem;
      position: relative;
      top: 0.6rem;
      vertical-align: top;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .detailinfo-bottom-div {
    position: fixed;
    bottom: 0;
    background: #ffffff;
    width: calc(100% - 3.0rem);
    box-shadow: 0rem -0.5rem 1.0rem 0rem rgba(19, 19, 19, 0.1);
    display: flex;
    justify-content: space-between;
    height: 5.8rem;
    padding: 0.6rem 1.5rem;

    .bottom-div-left {
      flex: 1;
    }

    .hotel-room-btn {
      flex: 1;
      width: 6.4rem;
      height: 2.2rem;
      font-size: 1.6rem;
      font-weight: 500;
      color: #ffffff;
      line-height: 2.2rem;
      background: linear-gradient(135deg, #ff7742 0%, #ff5a4b 100%);
      border-radius: 2.3rem;
      padding: 1.2rem 2.7rem;
      text-align: center;
    }
  }

  .room-price-div {
    padding-bottom: 0.5rem;

    .room-price-red {
      display: inline-block;
      min-width: 4.1rem;
      text-align: right;

      span {
        font-size: 1.2rem;
        font-weight: 400;
        color: #f84737;
        line-height: 1.7rem;
      }

      .room-price-number {
        font-size: 2.0rem;
        font-weight: 500;
      }
    }

    .room-price-text-img {
      height: 1.7rem;
      font-size: 1.2rem;
      font-weight: 400;
      color: #999999;
      line-height: 1.7rem;
      display: inline-block;
      width: 2.1rem;
      margin-left: 0.5rem;
    }
  }

  .room-orange-text-img {
    height: 1.6rem;
    font-size: 1.1rem;
    font-weight: 400;
    color: #ff6253;
    line-height: 1.6rem;

    img {
      width: 0.8rem;
      height: 0.8rem;
    }
  }

  .checkin-info {
    padding: 0rem 1.5rem 10.0rem;
    background-color: #fbfbfb;

    .one-title {
      height: 2.5rem;
      font-size: 1.8rem;
      font-weight: 500;
      color: #333333;
      line-height: 2.5rem;
      position: relative;
      margin-top: 3.0rem;

      img {
        width: 2.0rem;
        height: 2.0rem;
        position: relative;
        top: 0.2rem;
        margin-right: 0.5rem;
      }
    }

    .read-text,.read-text-little,.read-text-little-old {
      min-height: 2.1rem;
      font-size: 1.5rem;
      font-weight: 400;
      color: #333333;
      line-height: 2.1rem;
      word-break: break-word;
    }
    .read-text-little{
      min-height: 2rem;
      font-size: 1.4rem;
      line-height: 2rem;
    }
    .read-text-little-old{
      margin-top: 1rem;
    }
    .read-right-indent {
      margin: 1.0rem 0 0 2.5rem;
      line-height: 2.6rem;
    }

    .deail-right-text {
      position: absolute;
      top: 0;
      right: 0;
      height: 1.7rem;
      font-size: 1.2rem;
      font-weight: 400;
      color: #666666;
      line-height: 1.7rem;

      img {
        width: 0.8rem;
        height: 0.8rem;
        margin-bottom: 0.2rem;
      }
    }

    .check-in-out {
      display: flex;

      div {
        flex: 1;
        padding: 1.0rem 0 0 0;

        div:nth-of-type(1) {
          height: 2.0rem;
          font-size: 1.4rem;
          font-weight: 400;
          color: #999999;
          line-height: 2.0rem;
          padding: 0 0 0 0;
        }

        div:nth-of-type(2) {
          padding: 0.5rem 0 0 0;
          height: 2.0rem;
          font-size: 1.4rem;
          font-weight: 400;
          color: #333333;
          line-height: 2.0rem;
        }
      }
    }
  }

  .hotel-facility-info {
    padding: 3.0rem 1.5rem 10.0rem;

    .hotel-facility-title {
      height: 2.5rem;
      font-size: 1.8rem;
      font-weight: 500;
      color: #333333;
      line-height: 2.5rem;
    }

    .hotel-facility-div {
      display: flex;

      div {
        flex: 1;

        .read-div-text {
          padding: 1.0rem 0 0 0;
          height: 2.0rem;
          font-size: 1.4rem;
          font-weight: 400;
          line-height: 2.0rem;
          color: #666666;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
</style>